import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { tablet } from '../../../media';

export const ModalOverlay = styled(motion.div, {
  shouldForwardProp: (prop) => prop !== 'keyboardBottom',
})<{ keyboardBottom?: number }>`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: rgba(0, 0, 0, 0.4);
  z-index: 2500;
  display: flex;
  align-items: ${(p) => ((p.keyboardBottom ?? 0) > 0 ? 'flex-end' : 'center')};
  justify-content: center;
  padding: 16px;
  padding-bottom: ${(p) => 16 + (p.keyboardBottom ?? 0)}px;
  overscroll-behavior: none;
  touch-action: none;
  transition: padding-bottom 0.28s cubic-bezier(0.25, 0.1, 0.25, 1);
`;

export const ModalContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 16px;

  ${tablet`
    max-width: 720px;
  `}

  background: #1e1f22;
  box-shadow: 0px -2px 20px rgba(0, 0, 0, 0.45);
  border-radius: 16px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  gap: 24px;
  max-height: calc(100dvh - var(--keyboard-height, 0px) - 40px);
  overflow-y: auto;
  z-index: 3001;
  overscroll-behavior: contain;

  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.3s ease;

  &:hover {
    scrollbar-color: #3a3c44 transparent;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(58, 60, 68, 0);
    border-radius: 4px;
    transition: background 0.3s ease;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: #3a3c44;
  }
  &:hover::-webkit-scrollbar-thumb:hover {
    background: #4a4c54;
  }
`;

export const NotesHeader = styled.div`
  font-family:
    Inter,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  color: #e9ecf5;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`;

export const NoteArea = styled.textarea`
  font-family:
    Inter,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  min-height: 120px;
  max-height: 200px;
  padding: 12px;
  background: #25272c;
  box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.3) inset;
  border-radius: 12px;
  color: #e9ecf5;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
  border: none;
  resize: none;

  &::placeholder {
    color: rgba(183, 189, 203, 0.5);
    font-size: 15px;
  }

  &:focus {
    outline: none;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 32px;
`;

export const CancelButton = styled.button`
  color: #b7bdcb;
  font-size: 15px;
  font-family:
    Inter,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  font-weight: 600;
  line-height: 140%;
  word-wrap: break-word;
  height: 44px;
  padding: 12px 16px;
  overflow: hidden;
  border-radius: 12px;
  background: transparent;
  border: 0px;
  outline: 0px;
  cursor: pointer;
  line-height: 21px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SaveButton = styled.button`
  border: none;
  width: 108px;
  height: 44px;
  padding: 12px 24px;
  background: #5e84ed;
  overflow: hidden;
  border-radius: 12px;
  color: white;
  font-size: 15px;
  font-family:
    Inter,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  font-weight: 600;
  line-height: 21px;
  word-wrap: break-word;
  cursor: pointer;

  &:disabled {
    background: #b7bdcb;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
